import * as m from "mithril";
import AppContext from "../../context/AppContext";
import { NavBar } from '../../components/NavBar';
import buildLanguageChangeActions from "../common/LanguageNavActions";
import CustomSvgIcon from "../../components/CustomSvgIcon";

interface Attrs{
    appContext: AppContext,
    onBackPressed: () => void,
    onReload:() => void
}

function ContactPage(): m.Component<Attrs> {
    return {        
        view(vnode) {            
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let lang = messageProvider.getCurrentLang();
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return m('div', { class: "app-layout" },
                [
                    m(NavBar, {
                        title: messageProvider.get("nav_menu.contact"),
                        canBackPress: true,
                        onBackPressed: () => vnode.attrs.onBackPressed(),
                        actionItems: langChangeActionItems,
                    }),

                    m("div.app-area-main p-2", 
                        
                        m("a", {
                            "href": "tel:09777111811",
                            "style": "text-decoration:none"
                        },
                            m("div.card m-3", 
                                m("div.card-body", 
                                    m("div.d-flex", 
                                        m("div.bg-primary m-3", {
                                            style: {
                                                "width":"48px",
                                                "height":"48px",
                                                "border-radius":"50%",
                                                "padding":"12px"
                                            }
                                        },
                                            m(CustomSvgIcon, {iconType:'phone', themeCssClass:"svg-white svg-medium"})
                                        ),
                                        m("div.mt-3 mx-2", [
                                            m("div.text-body-sm text-secondary", messageProvider.get("contact.call_hotline")),
                                            m("div", {
                                                class: "lead font-weight-bold mt-1"
                                            }, "09 777 111 811")
                                        ]),                                                                 
                                    )  
                                )                                                 
                            )                        
                        )                                             
                    ),
                ]);
        }
    }
};

export default ContactPage;